const sliderData =[

    {
        id:1,
        Title:'Our Mission',
        description:' Providing a unique experience for Entrepreneurs, organizations and job seekers, by providing the best training and developing human capital for exceptional career and business results',
    },
    {
        id:2,
        Title:'Our Vision',
        description:'To be the number one go-to place for advanced training, capacity development content and business advisory services ',
    },
    {
        id:3,
        Title:'Our Values',
        description:'Employees who work at UrielSprout have INTEGRITY: -Innovate    -Nurture    -Teamwork   -Excellence     -Growth Mindset     -Respect for the Individual     -Intelligent    -Tenacity   -Youthful',
    }
    
]

export default sliderData;